import "../../../index.css";
import React, {useState, useContext, useEffect} from "react";
import { Loader } from '@fluentui/react-northstar';
import { TeamsFxContext } from "../../Context";
import * as microsoftTeams from "@microsoft/teams-js";

export const Settings = () =>{
//export function Settings() {
    const {userPrincipalName, accessToken} = useContext(TeamsFxContext);
    const [joke, setJoke] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(true);
    const [showJokes, setShowJokes] = React.useState(false); // State to track checkbox
    const message = "Apologies, the service is currently unavailable. Please try again later.";
    const reactFunctionEndpoint= process.env.REACT_APP_FUNCTION_ENDPOINT;
    const [accesstoken, setToken]= useState(null);

     useEffect(()=> {
            const fetchToken = async() =>{
            try{
                await microsoftTeams.app.initialize();
                const ssoToken =await microsoftTeams.authentication.getAuthToken();
                setToken(ssoToken);
            } catch (err){
                console.err("Token check error: ", err);
            }
            };
            fetchToken();
        },[]);

    /* useEffect(()=>{
    microsoftTeams.initialize();
    microsoftTeams.getContext(async (context) => {
    microsoftTeams.authentication.getAuthToken({
      successCallback: async(token) => {  
          setToken(token);
      },
      failureCallback: (error) => {
          console.error("Error getting token: ", error);
      }
    });
    });
  },[]); */


    useEffect(()=>{
        if (accesstoken) {
            fetchJokes();
        }
    },[accesstoken]);

    const fetchJokes = async ()=>{ 
        try{
            const response = await fetch(`${reactFunctionEndpoint}/api/getServiceNowAPIData?type=humor`,
                        {
                            method: "GET",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${accesstoken}`,
                            },
                        }
            );
            
            if (response.ok){
                const data = await response.json();
                setJoke(data);                    
            } else {
                console.log("Failed to fetch IT Jokes: ", response.status);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false);
        }
    };
    
    //React.useEffect(() => {
      /*   fetch('https://portal.supporttraytab.epiroc.com/api/getServiceNowAPIData').then(()=>{

            microsoftTeams.authentication.getAuthToken
            
        }) */

    const handleCheckboxChange = (e) => {
        setShowJokes(e.target.checked); // Update state based on checkbox
    };

    return (
        <div className="tabHeader">
            <p>IT Humour</p>

            {isLoading && <Loader />}

            {/* Display jokes only if the checkbox is checked */}
            {showJokes && joke && joke.length > 0 ? (
                joke.map((val, key) => (
                    <div className="jokecontent" key={key}>
                        {val.ITHumor}
                    </div>
                ))
            ) : (
                showJokes && !isLoading && <p>{message}</p>
            )}
            {/* Move the checkbox below the IT Humour message */}
            <label style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                marginLeft: '0px',  // Adjust to position the label to the left
                padding: '20px 0',
                top: '235px', position: 'absolute'
                }}>
                <input
                    type="checkbox"
                    checked={showJokes}
                    onChange={handleCheckboxChange}
                />
                Show IT Jokes
            </label>

        </div>
    );
}
